import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './offCanvas.css';

export default function BackdropOffcanvas() {
  // Access permissions array from Redux store
  const permissions = useSelector((state) => state.emp.permissions);
  // Get current location
  const location = useLocation();

  const product = [
    {
      "id": "DashBoard",
      "header": "DashBoard",
      "icon": "lni lni-grid-alt",
      "link": "/user/home"
    },
    {
      "id": "adminmanagementID",
      "header": "Admin",
      "icon": "lni lni-user",
      "Childs": [
        { "id": "functionalitiesID", "Name": "Functionalities", "link": "/user/functions" },
        { "id": "branchesID", "Name": "Branchs", "link": "/user/branchs" },
        { "id": "departmentsID", "Name": "Departments", "link": "/user/deps" },
        { "id": "jobpositionsID", "Name": "JobPositions", "link": "/user/positions" },
        { "id": "shiftsID", "Name": "Shifts", "link": "/user/shifts" },
      ]
    },
    {
      "id": "employeemanagementID",
      "header": "Employee",
      "icon": "lni lni-users",
      "Childs": [
        { "id": "employeelistID", "Name": "Total Employees", "link": "/user/emp" },
        { "id": "employeeaddID", "Name": "Add Employee", "link": "/user/addemp" },
        { "id": "salaryslipsID", "Name": "Salary Slips", "link": "/user/salaryslip" },
        { "id": "coursesID", "Name": "Courses", "link": "/user/courses" },
        { "id": "subjectsID", "Name": "Subjects", "link": "/user/subcourses" }
      ]
    },
    {
      "id": "leavemanagementID",
      "header": "Leaves",
      "icon": "lni lni-protection",
      "Childs": [
        { "id": "todayleavesID", "Name": "Today Leaves", "link": "/user/todayLeaves" },
        { "id": "leaverequestsID", "Name": "Leave Requests", "link": "/user/leaveRequest" },
        { "id": "leavereportID", "Name": "Leave Report", "link": "/user/leaveReport" },
        { "id": "myleavesID", "Name": "My Leaves", "link": "/user/selfLeave" },
        { "id": "companyleavesID", "Name": "Company Leaves", "link": "/user/leaveShow" },
        { "id": "balanceleavesID", "Name": "Balance Leaves", "link": "/user/blncleaves" },
      ]
    },
    {
      "id": "rolesmanagementID",
      "header": "Roles",
      "icon": "lni lni-layout",
      "Childs": [
        { "id": "totalrolesID", "Name": "Total Roles", "link": "/user/userdetails" },
      ]
    },
    {
      "id": "attendencemanagementID",
      "header": "Attendence",
      "icon": "bi bi-calendar2-week",
      "Childs": [
        { "id": "allattendanceID", "Name": "All Attendence", "link": "/user/attendence" },
        { "id": "employeeattendancereportID", "Name": "Attendance Report", "link": "/user/attreport" },
        { "id": "attendanceregularizationID", "Name": "Regularization", "link": "/user/regular" },
        { "id": "earlyandlateID", "Name": "Early & Late", "link": "/user/earlyLate" },
        { "id": "myattendanceID", "Name": "My Attendence", "link": "/user/myattendence" },
        { "id": "workinghoursID", "Name": "Working Hours", "link": "/user/workinghours" }
      ]
    },
    {
      "id": "vacationcampID",
      "header": "VacationCamp",
      "icon": "bi bi-book",
      "Childs": [
        { "id": "liststudentsID", "Name": "List Students", "link": "/user/listing" },
        { "id": "addstudentsID", "Name": "Add Students", "link": "/user/addstd" },
        { "id": "batchesID", "Name": "Batches", "link": "/user/batches" },
        { "id": "studentattendancereportID", "Name": "Attendance Report", "link": "/user/streport" },
        { "id": "feereportID", "Name": "Fee Report", "link": "/user/feereport" }
      ]
    }
  ];

  // Filter the product array based on permissions, always including DashBoard
  const filteredProduct = product.filter((item) =>
    item.id === "DashBoard" || permissions.includes(item.id)
  );

  return (
    <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel" style={{ width: '250px' }}>
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="offcanvasExampleLabel">Prosevo</h5>
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div className="offcanvas-body">
        <div className="accordion accordion-flush p-0" id="accordionFlushExample">
          {filteredProduct.map((item, index) => {
            // Check if parent item or any child is active
            const isParentActive = item.link === location.pathname || 
              (item.Childs && item.Childs.some(child => child.link === location.pathname));

            return (
              <div className="accordion-item w-100" key={index}>
                <div className={`button_Container w-100 ${isParentActive ? 'active' : ''}`}>
                  {item.link ? (
                    <Link
                      to={item.link}
                      className="w-100 text-decoration-none d-flex align-items-center h-100"
                      style={{ color: 'inherit' }}
                    >
                      <i className={`icons ${item.icon} d-flex justify-content-center`}></i>
                      <p className="icon-text mb-0" style={{ display: 'block', opacity: '100%' }}>
                        {item.header}
                      </p>
                    </Link>
                  ) : (
                    <>
                      <i className={`icons ${item.icon} d-flex justify-content-center`}></i>
                      <p className="icon-text mb-0" style={{ display: 'block', opacity: '100%' }}>
                        {item.header}
                      </p>
                    </>
                  )}
                  {item.Childs && (
                    <button
                      className="accordion-button collapsed d-flex justify-content-center text-black"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#flush-collapse${item.id}`}
                      aria-expanded={isParentActive ? 'true' : 'false'}
                      aria-controls={`flush-collapse${item.id}`}
                    >
                      <i className="lni lni-chevron-down" style={{ display: 'block' }}></i>
                    </button>
                  )}
                </div>
                {item.Childs && (
                  <div
                    id={`flush-collapse${item.id}`}
                    className={`accordion-collapse collapse ${isParentActive ? 'show' : ''}`}
                    data-bs-parent="#accordionFlushExample"
                  >
                    <div className="accordion-body">
                      {item.Childs.map((child, childIndex) => {
                        const isChildActive = child.link === location.pathname;
                        return child.link ? (
                          <Link
                            key={childIndex}
                            to={child.link}
                            className={`btn w-100 text-start text-decoration-none p-0 ${isChildActive ? 'active' : ''}`}
                            style={{ zIndex: '10', color: 'inherit' }}
                          >
                            <button className='w-100 ps-5'>{child.Name}</button>
                          </Link>
                        ) : (
                          <button
                            key={childIndex}
                            className={`btn w-100 text-start p-0 ${isChildActive ? 'active' : ''}`}
                            style={{ zIndex: '10' }}
                          >
                            {child.Name}
                          </button>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}